
import { defineComponent, PropType } from 'vue';
import ButtonInputStyleProvider from '@/components/style-providers/ButtonInputStyleProvider.vue';
import { ButtonTypes } from '@/types';

export default defineComponent({
  name: 'ButtonInput',
  components: {
    ButtonInputStyleProvider
  },
  props: {
    styleType: {
      type: String as PropType<ButtonTypes>,
      required: false,
      default: 'primary'
    },
    type: {
      type: String as PropType<'button' | 'submit'>,
      default: 'button'
    }
  }
});
